export const MIN_OPTIONS_FOR_DROPDOWN = 6;
